<template>
  <!-- field elements, input, select, etc. -->
  <component :is="getType(field.type)" :fieldData="field" ref="component" />
</template>

<script>
import InputText from "@/components/form/InputText";
import InputTel from "@/components/form/InputTel";
import InputEmail from "@/components/form/InputEmail";
import InputNumber from "@/components/form/InputNumber";
import TextArea from "@/components/form/TextArea";
import TermsOfService from "@/components/form/TermsOfService";
import FormActions from "@/components/form/FormActions";
import Dropdown from "@/components/form/Dropdown";
import Radios from "@/components/form/Radios";
import Checkbox from "@/components/form/Checkbox";
import Checkboxes from "@/components/form/Checkboxes";
import FormFieldset from "@/components/form/FormFieldset";
import Date from "@/components/form/InputDate";

const mapping = {
  textfield: "InputText",
  tel: "InputTel",
  email: "InputEmail",
  number: "InputNumber",
  textarea: "TextArea",
  radios: "Radios",
  select: "Dropdown",
  checkbox: "Checkbox",
  checkboxes: "Checkboxes",
  fieldset: "FormFieldset",
  date: "Date"
};

export default {
  components: {
    InputText,
    InputTel,
    InputEmail,
    InputNumber,
    TextArea,
    TermsOfService,
    FormActions,
    Dropdown,
    Radios,
    Checkbox,
    Checkboxes,
    FormFieldset,
    Date
  },
  name: "form-component",
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      newletterField: {
        name: "Newsletter",
        crm_id: "WK_eNews",
        title: this.$t("register.newsletter"),
      },
      valid: false,
    };
  },
  methods: {
    getType(field) {
      return mapping[field];
    },
    validateField() {
      this.$refs.component.validateField();
      this.valid = this.$refs.component.valid;
    }
  },
};
</script>